var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isDefaultLogin == true && !_vm.accountId)?_c('login-default'):_vm._e(),(_vm.isDefaultLogin == false && !_vm.accountId)?_c('login-reseller'):_vm._e(),(_vm.isCustomer)?_c('login-customer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }